'use strict';
import React from 'react';

/**
 * DropdownMenuItem component.
 *
 * @extends {React.Component}
 */
class DropdownMenuItem extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render() {
    const {children, ...otherProps} = this.props;

    return (
      <li {...otherProps} className="DropDown-menuItem">
        {children}
      </li>
    );
  }
}

export default DropdownMenuItem;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/dropdown/dropdownMenuItem.jsx